// Migrated from app/assets/javascripts/admin_ext.js.coffee
// Converted from CoffeeScript to JavaScript

import 'jquery'

$(function() {
  $('.remove_fields').click(function() {
    if (confirm("Weet u het zeker?")) {
      remove_fields($(this));
    }
  });

  $('.add_fields').click(function() {
    add_fields($(this), $(this).data('association'), $(this).data('fields'));
  });

  $('.slide_toggle').click(function() {
    var id = $(this).data('slide-id');
    $("#" + id).slideToggle();
  });

  $(".best_in_place").best_in_place();
});
